import { LayoutType, withLayout } from 'hocs/with-layout';
import { VaultReminder } from './vault-reminder';

const WrappedVaultReminder = withLayout(
  LayoutType.WithOldNavAndFooter,
  VaultReminder,
);

export { WrappedVaultReminder as VaultReminder };
